export function executeWithInterval(task, onProgress, rate) {
    return new Promise((resolve, reject) => {
        let intervalId = setInterval(onProgress, rate);

        task
            .then((result) => {
                clearInterval(intervalId);
                resolve(result);
            })
            .catch((error) => {
                clearInterval(intervalId);
                reject(error);
            });
    });
}

export function executeWithTimeout(task, onCancelTask, timeout) {
    return new Promise((resolve, reject) => {
        let timeoutId = setTimeout(() => {
            onCancelTask();
            reject(new Error('Timeout'));
        }, timeout);

        task
            .then((result) => {
                clearTimeout(timeoutId);
                resolve(result);
            })
            .catch((error) => {
                clearTimeout(timeoutId);
                reject(error);
            });
    });
}
